export const DEFAULT_TABLE_KEY = 'default';

export const CLICKABLE_ROW_CLASS = 'dynamic-table-row-clickable';

export const ROW_HINT_DELAY_MS = 1000;

const INTERACTIVE_SELECTOR =
  'button, a, input, textarea, select, label, [role="button"], [role="checkbox"], [role="combobox"], [role="menuitem"], [role="option"]';

export const isRowDoubleClickTarget = (
  row: HTMLElement,
  target: EventTarget
): boolean =>
  target instanceof Element &&
  row.contains(target) &&
  !target.closest(INTERACTIVE_SELECTOR);

export const clearTextSelection = (): void => {
  window.getSelection()?.removeAllRanges();
};
